export default "__VITE_ASSET__DD_MGJX3__"